export default __webpack_public_path__ + "ff989755f185dbf0877742483acffded.png";